// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"9a1a26e7","275":"b2141a23","279":"6d9b3c42","453":"1abd557b"}[chunkId] + ".chunk.js";
};